
































































































import Vue from "vue";
import { AppConstants as _app } from "@/shared/app.constants";
import { Utilities as utils } from "@/shared/utilities";
import { Component } from "vue-property-decorator";
import CommunicationsGridComponent from './grid.vue';
@Component({
  components:{
    CommunicationsGridComponent,
    DialogComponent: () => import("@/components/common/Dialog/DialogComponent.vue"),
    DocumentForm: () => import ("@/components/common/Inputs/Documents.vue")
  }
})
export default class CommunicationsComponent extends Vue {
  headers=_app.commiunicationHeadersAdmin
  items=_app.commiunicationReportHeaders;
  languages = _app.languages;
  tableItems :any=[];
  docTags: any = [];
  displayData=true;
  context="create"
  snackbar=false;
  snackBarColor="green";
  message=""
  search=""
  id=0;
  showDocs: boolean = false;
  docActions = [
    { event: 'close', text: 'Close'}
  ];
  docInfo: any = {};
  selectedItem: any = {};
  docTag: number;
  docs: Array<any> = [];
  mounted()
  {
    this.$services.commiunicationReport.List().then(resp=>{
      if(resp.Result=="OK"){
        this.tableItems=resp.Record.CallCommunicationTemplateList;
        this.items.find((x) => x.text == "Initiative" ).items = resp.Record.InitiativeId ;
        this.items.find((x) => x.text == "Template" ).items = resp.Record.TemplateId ;
        this.docTag = resp.Record.DocumentTag;
        this.docTags = resp.Record.Tags;
        this.docs = resp.Record.Documents;
        }
    })
  }
  addData()
  {
    this.displayData=false
    this.context="create";
  }
  close()
  {
    this.displayData=true
  }
  closeDocs() {
    this.docs = [ ...this.docs.filter(x => x.transactionId != this.selectedItem.CallCommunicationTemplateId), ...this.docInfo.docs ]
    this.showDocs = false;
  }
  update(item)
  {
    this.context="update"
    this.displayData=false
    this.id=item.CallCommunicationTemplateId
  }
  openDocuments(item) {
    this.selectedItem = item;
    this.docInfo.docs = this.docs.filter(x => x.transactionId == item.CallCommunicationTemplateId);
    this.showDocs = true;
  }
  save(e)
  {
    this.$services.commiunicationReport.Create(e).then(resp=>{
      if(resp.Result=="OK")
      {
        this.displayData=true
        this.snackbar=true
        this.message=resp.Message
        this.$services.commiunicationReport.List().then(resp=>{
          if(resp.Result=="OK"){
            this.tableItems=resp.Record.CallCommunicationTemplateList;
            this.items.find((x) => x.text == "Initiative" ).items = resp.Record.InitiativeId ;
            this.items.find((x) => x.text == "Template" ).items = resp.Record.TemplateId ;
            }
        })
      }
      else
      {
        this.displayData=true
        this.snackbar=true
        this.snackBarColor="red"
        this.message=resp.Message
      }
    })
  }
  updateData(e)
  {
    this.$services.commiunicationReport.Update(this.id,e).then(resp=>{
      if(resp.Result=="OK")
      {
        this.displayData=true
        this.snackbar=true
        this.message=resp.Message
        this.$services.commiunicationReport.List().then(resp=>{
          if(resp.Result=="OK"){
            this.tableItems=resp.Record.CallCommunicationTemplateList;
            this.items.find((x) => x.text == "Initiative" ).items = resp.Record.InitiativeId ;
            this.items.find((x) => x.text == "Template" ).items = resp.Record.TemplateId ;
            }
        })
      }
      else
      {
        this.displayData=true
        this.snackbar=true
        this.snackBarColor="red"
        this.message=resp.Message
      }
    })
  }
  Delete(item)
  {
    if (confirm("Are you sure to delete this record?")) {
      this.$services.commiunicationReport.Delete(item.CallCommunicationTemplateId).then((data) => {
        if (data.Result == "OK") {
          this.snackbar = true;
          this.snackBarColor = "green";
          this.message = data.Message;
          this.$services.commiunicationReport.List().then(resp=>{
          if(resp.Result=="OK"){
            this.tableItems=resp.Record.CallCommunicationTemplateList;
            this.items.find((x) => x.text == "Initiative" ).items = resp.Record.InitiativeId ;
            this.items.find((x) => x.text == "Template" ).items = resp.Record.TemplateId ;
            }
        })
        } else {
          this.snackbar = true;
          this.snackBarColor = "red";
          this.message = "Failed to save Data";
        }
      });
    }
  }
}
